<template>
    <div>
        <!--Dashboard Contratos-->
        <v-row class="ma-0">
            <v-col cols="12">
                <div class="margen d-flex">
                    <hr class="vr"/>
                    <p class="tblName">{{ tituloDashboard }}</p>
                </div>
            </v-col>
            <!--Filtros-->
            <v-container fluid>
                <v-row class="ma-0 px-4">
                    <v-col xs="12" md="6" xl="2" class="px-2" v-if="rol == 'root'">
                        <v-autocomplete 
                            outlined 
                            :items="itemsClientes" 
                            item-text="nombre"
                            item-value="id" 
                            label="Cliente" 
                            hide-details
                            v-model="cliente_id">
                        </v-autocomplete>
                    </v-col>
                    <v-col xs="12" md="6" xl="2" class="px-2" v-if="rol == 'root' && esDashboardContratos">
                        <v-autocomplete 
                            outlined 
                            :items="itemsRegistrosPatronales" 
                            item-text="nombreClave"
                            item-value="id" 
                            label="Registro patronal" 
                            hide-details
                            v-model="rp_id">
                        </v-autocomplete>
                    </v-col>
                    <v-col xs="12" md="6" xl="2" class="px-2" v-if="rol == 'root' || rol == 'admin'">
                        <v-autocomplete 
                            outlined 
                            :items="itemsEmpresa" 
                            item-text="nombre"
                            item-value="id" 
                            label="Empresa" 
                            hide-details
                            v-model="empresa_id">
                        </v-autocomplete>
                    </v-col>
                    <v-col xs="12" md="6" xl="2" class="px-2" v-if="esDashboardContratos && (rol == 'root' || rol == 'admin' || rol == 'admin-empresa')">
                       <MultipleAutocomplete
                            outlined
                            :items="itemsSucursal"
                            item_text="nombre"
                            @dataMultiple="(data)=> sucursalesSeleccionadas = data"
                            :valorDefecto="sucursalesSeleccionadas"
                            label="Sucursales"
                            ref="multSucursal"
                            hide-details
                       />
                    </v-col>
                    <v-col xs="12" md="6" xl="2" class="px-2 ">
                        <VuetifyDatePicker 
                        outlined 
                        :label="esDashboardContratos ? 'Fecha inicial de elaboración' : 'Fecha inicial'" 
                        :valorDefecto="fechaInicio"
                        v-model="fechaInicio" 
                        placeholder="dd/mm/aaaa" 
                        hide-details
                        ref="fechaInicio" />
                    </v-col>
                    <v-col xs="12" md="6" xl="2" class="px-2 ">
                        <VuetifyDatePicker 
                        outlined 
                        :label="esDashboardContratos ? 'Fecha final de elaboración' : 'Fecha final'" 
                        :valorDefecto="fechaFinal"
                        v-model="fechaFinal" 
                        placeholder="dd/mm/aaaa" 
                        hide-details
                        ref="fechaFinal" />
                    </v-col>
                    <v-col xs="12" md="6" xl="4" class="px-2 d-flex align-center">
                        <v-btn
                            class="btnGuardar mx-0"
                            elevation="0"
                            @click="cambiarDashboard()" 
                        >
                            {{ labelBtnCambio }}
                        </v-btn>
                        <v-btn
                            class="ml-2"
                            @click="filtrar" 
                            fab
                            :dark="!filtroVacio"
                            small
                            elevation="0"
                            color="#1e2245"
                            :disabled="filtroVacio"
                        >
                            <v-icon class="tamIconoBoton">mdi-filter-variant</v-icon>
                        </v-btn>
                        <button
                            class="btnCerrar mx-2"
                            @click="borrarFiltros()" 
                        >
                            Restaurar
                        </button>
                        <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    v-on="on"
                                    slot="activator"
                                    class="botonHover"
                                    icon
                                    fab
                                    dark
                                    @click=""
                                    small
                                >
                                    <v-icon class="tamIconoBoton" color="#828282">download</v-icon>
                                </v-btn>
                            </template>
                            <span>Descargar reporte</span>
                        </v-tooltip> -->
                    </v-col>
                </v-row>
            </v-container>
            <!--Datos-->
            <div v-if="isLoading" class="align-center justify-center text-center" style="width: 100%; margin-top: 100px;">
                <v-progress-circular
                    indeterminate
                    :size="100"
                    :width="7"
                    color="#2DB9D1"
                >
                    <v-img
                        src="/static/icon/favicon.ico"
                        :width="60"
                    ></v-img>
                </v-progress-circular>
                <p class="mt-5">Cargando...</p>
            </div>
            <DashboardContratos
                v-else-if="esDashboardContratos"
                :itemsContratosElaborados="itemsContratosElaborados"
                :itemsEmpleadosActivos="itemsEmpleadosActivos"
                :itemsEmpleadosInactivos="itemsEmpleadosInactivos"
                :itemsContratosStatus="itemsContratosStatus"
                :itemsContratosTipo="itemsContratosTipo"
            />
            <DashboardIndicadores
                v-else
                :infoContratosLaborales="objContratosLaborales"
                :infoKitsBajas="objKitsBajas"
                :infoAudienciasConciliacion="objAudienciasConciliacion"
                :infoPensionesAlimenticias="objPensionesAlimenticias"
                :infoBajasProgramadas="objBajasProgramadas"
            />        
        </v-row>
        <template v-if="primer_login">
            <v-row justify-center>
                <v-dialog
                    v-model="dialog_primer_login"
                    persistent
                    max-width="420px"
                >
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>
                    <v-card>
                        <ValidationObserver ref="form" v-slot="{ invalid }">
                            <v-card-title class="padding-x50 pt-9 pb-8">
                                <span class="titleModal" v-text="titulo_modal"></span>
                            </v-card-title>
                            <v-card-text class="card_texto">
                                <v-container grid-list-md key="unique"> 
                                    <v-row class="align-center justify-center"><span id="span_cambio">Por políticas, es requerido cambiar la contraseña.</span></v-row>
                                    <v-row class="pt-4">
                                        <v-col cols="12" xs="12" sm="12" md="12" class="my-0 pa-0">
                                            <ValidationProvider v-slot="{ errors }" name="Contraseña" rules="required|verify_password">
                                                <v-text-field
                                                    outlined
                                                    label="Nueva contraseña"
                                                    v-model="nuevo_password"
                                                    id="nuevo_password"
                                                    class="py-0"
                                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                    @click:append="show1 = !show1"
                                                    :type="show1 ? 'text' : 'password'"
                                                    auto
                                                    :error-messages="errors" 
                                                    required
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="12" md="12" class="my-0 pa-0">
                                            <ValidationProvider v-slot="{ errors }" name="Confirmación" rules="required|verify_password">
                                                <v-text-field
                                                    outlined
                                                    label="Confirmar la contraseña"
                                                    v-model="confirmacion"
                                                    id="verificar_password"
                                                    class="py-0"
                                                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                                    @click:append="show2 = !show2"
                                                    :type="show2 ? 'text' : 'password'"
                                                    auto
                                                    @keyup.enter="verificar('confirmacion')"
                                                    :error-messages="errors" 
                                                    required
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                        <div
                                            v-if="password_igual"
                                            class="v-stepper__label"
                                            style="color:#FF5454; padding-left: 3%; margin-top: -5%;"
                                        >
                                            Las contraseñas no son iguales, favor de verificar.
                                        </div>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-end card_accion pt-0">
                                <v-btn color="btnGuardar" @click="verificar()">Guardar</v-btn>
                            </v-card-actions>
                        </ValidationObserver>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <!-- <DashboardNominas/> -->
       <!--  <template v-if="rol=='empleado'">
            <DashboardNominas/>
        </template>
        <template v-if="rol!='empleado'">
            <template
                v-if="rol == 'root'"
            >
                <DashboardNominas/>
            </template>
            <template v-else-if="rol == 'admin-depto'">
                <DashboardGDTH/>
            </template> 
            <template v-else>
                <template
                    v-if="tipoDashboard == 'gdth'"
                >
                    <DashboardGDTH/>
                </template>
                <template
                    v-else
                >
                    <DashboardNominas/>
                </template>

                
            </template>
            
        </template> -->
    </div>
</template>
<script>
//DASHBOARDS
import DashboardGDTH from '@/views/dashboards/DashboardGDTH'
import DashboardNominas from '@/views/dashboards/DashboardNominas'
import DashboardIndicadores from '@/views/dashboards/DashboardIndicadores.vue'
import DashboardContratos from './dashboards/DashboardContratos.vue';
//COMPONENTES
import MultipleAutocomplete from '@/components/VuetifyMultipleAutocomplete2.vue'
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';
//APIS
import apiDashboard from '@/api/dashboard.js'
import empresaApi from "@/api/empresas";
import sucursalApi from "@/api/sucursales";
import apiClientes from "@/api/clientes";
import apiRegistroPatronal from "@/api/nominas/registroPatronal";
import userApi from "@/api/usuarios";
//PLUGINS
import Notify from "@/plugins/notify";
import { mapActions, mapState } from "vuex";

export default {
    components: {
        //DashboardGDTH,
        //DashboardNominas,
        DashboardContratos,
        DashboardIndicadores,
        MultipleAutocomplete,
        VuetifyDatePicker,
    },
    data() {
        return {
            //tipoDashboard : 'payroll',
            datosLogin: null,
            rol: null,
            itemsRegistrosPatronales: [],
            itemsEmpresa: [],
            itemsSucursal: [],
            itemsClientes: [],
            rp_id:null,
            empresa_id: null,
            cliente_id: null,
            sucursalesSeleccionadas: [],
            fechaInicio: null,
            fechaFinal: null,
            itemsContratosStatus: [],
            itemsContratosTipo: [],
            itemsContratosElaborados: [],
            itemsEmpleadosActivos: [],
            itemsEmpleadosInactivos: [],
            isLoading: false,
            primer_login: false,
            titulo_modal: "¿Cambiar contraseña?",
            dialog_primer_login: false,
            nuevo_password: "",
            confirmacion: "",
            password_igual: false,
            user_vuex : {
                email: "",
                password: ""
            },
            usuario		        : {
				id                  : "",
				nombre              : "",
				apellido_paterno	: "",
				apellido_materno	: "",
				puesto				: "",
				email				: "",
				fecha_nacimiento	: "",
				telefono			: "",
				celular				: "",
				password			: "",
				primer_inicio_sesion: "",
				rol_id				: "",
			},
            show1		        : false,
			show2		        : false,
            tituloDashboard: "Control de contratos",
            labelBtnCambio: "Indicadores laborales",
            esDashboardContratos: true,
            objContratosLaborales: {},
            objKitsBajas: {},
            objAudienciasConciliacion: {},
            objPensionesAlimenticias: {},
            objBajasProgramadas: {},
        }
    },
    computed:{
        ...mapState("auth",["datos","user"]),
        filtroVacio() {
            return !this.cliente_id && 
                   !this.rp_id && 
                   !this.empresa_id && 
                   this.sucursalesSeleccionadas.length === 0 && 
                   !this.fechaInicio && 
                   !this.fechaFinal;
        }
    },
    watch:{
         cliente_id:function(val){
             if(val !== null){
                //console.log('dentro: ', val)
                this.getEmpresas()
                this.getRegistrosPatronales()
            }
         },
         empresa_id:function(val){
             if(val !== null){
                //console.log('dentro: ', val)
                this.getSucursales(val)
            }
         },
         esDashboardContratos:function(val){
            this.limpiarDatos()
            if(val == true){
                this.traerDatos()
            }else{
                this.traerDatosIndicadores()
            }
         }
    },
    methods: {
        ...mapActions("auth", ["logout", "update_password", "update_cliente"]),

        async inicio (){
            if(this.datos.primer_inicio_sesion == true){
                this.primer_login = true
                this.dialog_primer_login = true
                setTimeout(function(){
                    document.getElementById("nuevo_password").focus()
                },250)
            }
        },
        filtrar(){
            if(this.esDashboardContratos){
                this.traerDatos()
            }else{
                this.traerDatosIndicadores()
            }
        },
        cambiarDashboard(){
            this.esDashboardContratos = !this.esDashboardContratos
            if(this.esDashboardContratos){
                this.tituloDashboard = "Control de contratos"
                this.labelBtnCambio = "Indicadores laborales"
            }
            else{
                this.tituloDashboard = "Indicadores laborales"
                this.labelBtnCambio = "Control de contratos"
            }
        },

        async update() {
			this.llena_datos();
			await this.update_password(this.user_vuex);
			await userApi.updatePassword(this.usuario).then((response) => {
					userApi.getUsuario(this.usuario.id).then((response) => this.update_cliente(response))
					.catch((err) => console.log(err));
					this.cerrarModal();
					this.respuesta_ok("cliker® ya esta listo.");
				})
				.catch((err) => this.respuesta_error(err));
		},
		verificar() {
			this.$refs.form.validate().then(success => {
				if(!success) {
                    return;
                }
				if (success) {
					if (this.confirmacion == this.nuevo_password) {
						this.password_igual = false;
						this.update();
					} 
					else {
						this.password_igual = true;
					}
				}
			});
		},
        llena_datos() {
			this.usuario.id 				= this.datos.id;
			this.usuario.nombre 			= this.datos.nombre;
			this.usuario.apellido_paterno 	= this.datos.apellido_paterno;
			this.usuario.apellido_materno 	= this.datos.apellido_materno;
			this.usuario.puesto 			= this.datos.puesto;
			this.usuario.email 				= this.datos.email;
			this.usuario.telefono 			= this.datos.telefono;
			this.usuario.celular 			= this.datos.celular;
			this.rol_nombre 				= this.datos.rol.display_name;
			this.usuario.rol_id				= this.datos.rol.id;
			this.usuario.primer_inicio_sesion = false;
			this.usuario.password 			= this.confirmacion;
			this.user_vuex.email 			= this.usuario.email;
			this.user_vuex.password 		= this.confirmacion;
			this.usuario.fecha_nacimiento 	= "";

			if (this.datos.fecha_nacimiento != null) {
				this.usuario.fecha_nacimiento = this.datos.fecha_nacimiento.replace(
				/^(\d{4})-(\d{2})-(\d{2})$/g,
				"$3/$2/$1"
				);
			}
		},
		cerrarModal() {
			this.dialog_grafica = false;
			this.dialog_primer_login = false;
			this.primer_login = false;
			this.usuario = {};
		},
        respuesta_error(err) {

			/* if(typeof err.response.data.error === 'string'){
				Notify.ErrorToast(err.response.data.error);
			}else{
				let error = Object.values(err.response.data.error);
				let leyenda = ``;

				for (var i = 0; i < error.length; i++) {
					leyenda+= `* ` + error[i] + `\n`;
				}

				Notify.ErrorToast(leyenda);
			} */
			Notify.Alert("Error", err.response.data.error);
		},
		respuesta_ok(msj = "") {
			this.cerrarModal();
			this.dialog = false;
			Notify.Success("Operación exitosa", msj);
		},
        traerDatos(){
            this.isLoading = true
            let params = {
                cliente_id: this.cliente_id,
                empresa_id: this.empresa_id,
                arrSucursal: this.sucursalesSeleccionadas,
                registro_patronal_id: this.rp_id,
                fecha_inicio: this.fechaInicio,
                fecha_fin: this.fechaFinal
            }

            apiDashboard.getData(params).then((response) => {
                // console.log(response.contratos_status.length)
                this.itemsContratosStatus = response.contratos_status.map((item) => ({label: item.status, value: item.cantidad}))
                this.itemsContratosTipo = response.contratos_tipo.map((item) => ({label: item.tipo, value: item.cantidad}))
                this.itemsContratosElaborados = response.contratos
                this.itemsEmpleadosActivos = response.empleados_activos
                this.itemsEmpleadosInactivos = response.empleados_inactivos
                this.isLoading = false
            }).catch((error) => {
                console.log('Hubo un error')
                console.log(error)
            })


        },
        traerDatosIndicadores(){
            this.isLoading = true
            let params = {
                cliente_id: this.cliente_id,
                empresa_id: this.empresa_id,
                fecha_inicio: this.fechaInicio,
                fecha_final: this.fechaFinal
            }

            apiDashboard.getDashboardIndicadores(params).then((response) => {
                console.log(response)
                this.objContratosLaborales = response.contratos_laborales
                this.objKitsBajas = response.kits_baja
                this.objAudienciasConciliacion = response.audiencias
                this.objPensionesAlimenticias = response.pensiones
                this.objBajasProgramadas = response.bajas_programadas            
                this.isLoading = false
            }).catch((error) => {
                console.log('Hubo un error al cargar datos indicadores')
                console.log(error)
            })


        },
        limpiarDatos(){
            this.infoContratosLaborales = {}
            this.infoKitsBajas = {}
            this.infoAudienciasConciliacion = {}
            this.infoPensionesAlimenticias = {}
            this.infoBajasProgramadas = {}
            this.itemsContratosStatus = []
            this.itemsContratosTipo = []
            this.itemsContratosElaborados = []
            this.itemsEmpleadosActivos = []
            this.itemsEmpleadosInactivos = []
        },
        borrarFiltros(){
            if(this.rol == 'root'){
                this.cliente_id = null
            }
            if(this.rol == 'admin' || this.rol == 'root'){
                this.empresa_id = null
                this.sucursalesSeleccionadas = []
                this.itemsSucursal = []
            }
            if(this.rol == 'admin-empresa'){
                this.sucursalesSeleccionadas = []
            }
            this.rp_id = null
            this.fechaFinal = null
            this.fechaInicio = null
        },
        async getRegistrosPatronales() {
            this.itemsRegistrosPatronales = [];

            let param = { 
                activo: true, 
                paginate: false, 
                cliente_id: this.datosLogin.cliente_id
            };

            if(this.rol == 'root'){
                param.cliente_id = this.cliente_id
            }

            await apiRegistroPatronal.find(param).then(response => {
                // this.itemsRegistrosPatronales = response.data;
                let format = response.data;
                if(response.data.length != 0){
                    format.forEach( item => {
                        item.nombreClave = item.nombre + ' - ' + item.clave
                        this.itemsRegistrosPatronales.push(item);
                    })
                }
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los registros patronales.");
            });
            
        },
        async getEmpresas() {

            let param = { activo: true, paginate: false,cliente_id: this.datosLogin.cliente_id};
            if(this.rol == 'root'){
                param.cliente_id = this.cliente_id
            }
            
            await empresaApi
                    .getEmpresas(param)
                    .then(response => {
                        this.itemsEmpresa = response.data;
                })
                .catch(err => {
                    console.error(err);
                    Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
                });
        },
        async getSucursales(id) {
            
            let parametros = { activo: true, paginate: false, empresa_id: id };
            await sucursalApi
                .getSucursales(parametros)
                .then(response => {
                    this.itemsSucursal = response.data;
                })
                .catch(err => {
                    console.error(err);
                    Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
                });
        },
        async getItemsClientes(){
            let parametros = { activo:true, paginate:false, order:"asc"}
            apiClientes.getClientes(parametros).then((response) => {
                this.itemsClientes = response.data;
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los Clientes.");
            });
        },
    },
    async created() {
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;
        this.tipoDashboard = this.datosLogin.tipo_dashboard;
        await this.inicio()

        if(this.rol == 'root'){
            await this.getItemsClientes()
        }
        else if(this.rol == 'admin'){
            this.cliente_id = this.datosLogin.cliente_id
            this.getRegistrosPatronales()
            this.getEmpresas()
        }
        else if(this.rol == 'admin-empresa'){
            this.cliente_id = this.datosLogin.cliente_id
            this.empresa_id = this.datosLogin.empresa_id
            this.getRegistrosPatronales()
            this.getEmpresas()
        }
        else if(this.rol == 'admin-sucursal'){
            this.cliente_id = this.datosLogin.cliente_id
            this.empresa_id = this.datosLogin.empresa_id
            this.sucursalesSeleccionadas.push(this.datosLogin.sucursal_id)
            this.getRegistrosPatronales()
            this.getEmpresas()
        }
        this.traerDatos()
        
    },
}
</script>
<style scoped>
.margen {
    height: 48px;
    margin-bottom: 10px;
    margin-left: 1px;
}

.btnGuardar {
    width: auto !important;
    min-width: max-content !important;
    white-space: nowrap !important;
}

.btnCerrar {
    border-radius: 4px;
    background-color: #e0e0e0 !important;
    color: #828282 !important;
    
}

</style>